import { PermissionsEnum } from "@/auth/interfaces";
import { SAVE_FLOTA_PEMISSIONS } from "@/erp/sytem-sttings/flotas/shared/constants";
import { hasAllPermissions, ROUTER_PATHS, TABLE_CONSTANTS_COLUMS, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { fetchGetKitInventario } from "@/shared/actions/erp/kitinventario/kitInventario.actions";
import { GeneralTable, LoaderComponent, SingleTableBoxScene } from "@/shared/components/ui";
import { IKitInventario } from "@/shared/interfaces/erp/inventario/kit-inventario.interface";
import { Edit } from "@mui/icons-material";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { useTableColumnsKit } from "../../shared/hook/useTableColumnsKit";
import { useNavigate } from "react-router-dom";
import InfoKitProductos from "../../shared/component/info-kit-productos/InfoKitProductos";

export default function KitInventarioPage() {


  const { columnKitInventario } = useTableColumnsKit()

  const navigate = useNavigate();


  const {
    pagination,
    setPagination,
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } = useTableServerSideFiltering();

  const {
    isLoading,
    isRefetching,
    data: dataKitInventario
  } = fetchGetKitInventario({
    page: pageIndex + 1,
    page_size: pageSize,
    ...filterObject,
    filterByState: false

  });

  if (isLoading) return <LoaderComponent />

  return (
    <>
      <SingleTableBoxScene title={"Kit Inventariable"}
        py={2}
        enableRedirect
        urlRedirect={ROUTER_PATHS.inventario.kitInventariableCreateNav}
      >
        <GeneralTable<IKitInventario>
          columns={columnKitInventario}
          data={dataKitInventario?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}

          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={dataKitInventario?.data?.count}

          ///* filters - server side
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableSorting={false}

          // // actions ========
          enableColumnActions={hasAllPermissions([
            ...SAVE_FLOTA_PEMISSIONS,
            PermissionsEnum.api_change_flota,
          ])}
          actionsColumnSize={TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL}

          // crud
          canEdit={false}
          canDelete={false}
          enableEditing={true}

          showCustomActionBtnSpace={true}
          customActionBtnSpace={(data) => {

            return (<>
              <Grid container>
                <Grid item>
                  <Tooltip title={'Editar'} placement="top">
                    <IconButton
                      onClick={() => {

                        navigate(`${ROUTER_PATHS.inventario.kitInventariableEdit}/${data.id_kitinventario}`)

                      }}
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            </>)

          }}
        />

      </SingleTableBoxScene >

      <InfoKitProductos />
    </>
  );

}